<f-data-card>
  <div class="container authentication">
    <div class="row authentication-top">
      <div class="col-md-12 col-lg-6 authentication-left">
        <h1 class="heading">Authentication</h1>
        <div class="error-wrapper" *ngIf="cusAccService.authSucessMsg()">
          <f-alert variant="success">{{validationSuccessMessage}}</f-alert>
        </div>
        <div class="card-row">
          <div class="card-left">
            <h3>Authentication Status</h3>
          </div>
          <div class="card-right">
            <p class="auth-status">
              <span [ngClass]="
                  cusAccService.identifyAuthenticateClass(
                    rootScope.activeCustTab.authenticateStatus
                  )
                "></span>
              {{ rootScope.activeCustTab.authenticateStatus }}
            </p>
            <!-- Added "rootScope.activeCustTab?.channel == channel.call" codition to show only call scenario for US CCR3-6018 -->
            <p *ngIf="rootScope.activeCustTab?.genesysAttributes?.CP_INDICATIVE_DATA_SECURED == true  && rootScope.activeCustTab?.channel == channel.call"
              class="font-normal auth-method"> [Indicative Data] </p>
          </div>
        </div>
        <f-alert variant="success" class="status-msg hide">Customer authentication is complete. Your call is now fully
          secured.</f-alert>
        <f-alert variant="info"
          *ngIf="this.rootScope.isLiveCall && !rootScope.customerTypeAPIFailure && !rootScope.activeCustTab.authenticationContents.authenticationConfigMiss && this.rootScope.activeCustTab?.CS_SECURITY_LEVEL != '4'"
          class="status-msg hide1">Some customer data
          may be unavailable until the call is fully
          authenticated.</f-alert>

        <f-alert variant="error" *ngIf="rootScope.activeCustTab.authenticationContents.authenticationConfigMiss"
          class="status-msg">
          AUTHCNF001: Authentication configuration missing for the selected Caller Type.
        </f-alert>


        <section *ngIf="rootScope.activeCustTab.authenticationContents.authenticationAPIfailure" class="error-wrapper">
          <f-alert variant="error">
            {{errorMsg}}
            <button (click)="tryAgainAuthenticationAPI()" class="btn-alert">Try again</button>
          </f-alert>
        </section>

        <section *ngIf="rootScope.customerTypeAPIFailure" class="error-wrapper">
          <f-alert variant="error">
            {{errorMsg}}
            <button (click)="apiService.getCustomerTypesAPI()" class="btn-alert">Try again</button>
          </f-alert>
        </section>
        <div class="card-row">
          <div class="card-left">
            <p class="customer-type">Who is it?</p>
            <!--label (Caller/Customer Type) name change for CCR1-5039-->
            <app-alight-drop-down [group]="rootScope.customerTypeForm" [controlName]="'customerType'" [required]="false"
              description="fieldValueDescription" [disable]="cusAccService.callerTypeValidation()"
              label="Caller/Customer Type" [value]="'fieldValue'" [list]="rootScope.customerTypeData"
              (change)="changeCustomerType($event)">
            </app-alight-drop-down>
          </div>
        </div>

      </div>
      <div class="col-md-12 col-lg-6 authentication-right">

        <div class="flex justify-space-between">
          <h1>{{rootScope.activeCustTab?.authenticationEgainContent?.overViewHtml?.name}}</h1>
          <button mat-button color="primary" class="show-hide" id="toggle-1" (click)="showContent = !showContent">
            {{ showContent ? "Show Less" : "Show More" }}
            <span *ngIf="!showContent"><i class="fa-regular fa-angle-down"></i></span>
            <span *ngIf="showContent"><i class="fa-regular fa-angle-up"></i></span>
          </button>
        </div>
        <div class="show-hide-data" *ngIf="showContent">
          <section *ngIf="rootScope.activeCustTab?.authenticationEgainContent?.overViewError">
            <f-alert variant="error" class="status-msg hide1">
              {{rootScope.activeCustTab?.authenticationEgainContent?.overViewError}} </f-alert>
          </section>

          <div class="authentication-content"
            [innerHTML]="rootScope.activeCustTab?.authenticationEgainContent?.overViewHtml?.content| safe: 'html'">
          </div>
        </div>
      </div>
    </div>

    <div class="row col-rev authentication-bottom">
      <div class="col-md-12 col-lg-6 authentication-left">
        <mat-accordion class="authentication-method">
          <!-- First Time User -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.FTU)" (closed)="closeAccState(eGainConfig.FTU)"
            [expanded]='menuExpansionType(eGainConfig.FTU)' *ngIf="isAuthenticationMethodVisible(eGainConfig.FTU)">
            <mat-expansion-panel-header>
              <mat-panel-title> First Time User </mat-panel-title>
            </mat-expansion-panel-header>
            <f-alert class="error-with-heading alert-info hide" variant="info">
              <h4>Customer Data Validated</h4>
              <p>The customer must create a PIN to complete the FTU Flow.</p>
            </f-alert>
            <p class="hide1">
              Enter the required customer information credentials below then
              click Validate:
            </p>

            <!-- <p>
              To fully secure the call, select one of the authentication methods below and complete the authentication.
            </p> -->
            <div class="ftu-form hide1">
              <div class="container validation-method">
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>FullName</mat-label>
                      <input matInput id="fullName" value="Al Borland" disabled="true" />
                    </mat-form-field>

                    <mat-checkbox class="verify-checkbox">
                      The customer’s name is verified</mat-checkbox>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>Date of Birth</mat-label>
                      <input matInput [formControl]="dateOfBirth" required id="dateOfBirth" value="12/12/1919" />
                      <mat-error *ngIf="dateOfBirth.invalid"><i class="fa-solid fa-circle-xmark"></i>{{
                        getErrorMessage() }}</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>Last 4 of National ID</mat-label>
                      <input matInput id="nid" value="1234" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>Postal Code</mat-label>
                      <input matInput id="pcode" value="1234" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row row-top-margin">
                  <div class="col-md-6 single-col">
                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>Hire Date</mat-label>
                      <input matInput id="hiredate" value="12/12/1919" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row footer-btn">
                  <div class="col-md-12">
                    <f-button text="Cancel" type="button" variant="action"></f-button>
                    <f-button text="Validate" type="submit" variant="progressive">
                    </f-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="pin-entry hide">
              <div class="pin-container">
                <div class="step-container flex justify-space-between">
                  <span class="step-val active"><span class="step-circle active"><span class="step-no">1</span></span>Go
                    to ALIS</span>
                  <!-- For tick icon use <i class="fa-solid fa-check"></i> -->
                  <span class="step-val"><span class="step-circle"><span class="step-no">2</span></span>Connecting to
                    ALIS</span>
                  <span class="step-val hide"><span class="step-circle"><span class="step-no">2</span></span>Transfer
                    the call</span>
                  <span class="step-val"><span class="step-circle"><span class="step-no">3</span></span>PIN Entry
                    complete</span>
                </div>
                <p class="pin-content hide1">
                  Go to ALIS to transfer the customer to the PIN Entry App.
                </p>
                <p class="pin-content hide">
                  The customer will be transferred to ALIS and enter their PIN.
                </p>
                <p class="pin-content hide">
                  After the transfer is complete, the customer will return to
                  the Care Portal.
                </p>
                <p class="pin-content hide">
                  <i class="fa-solid fa-circle-check"></i>
                  Success! The customer has completed the FTU flow.
                </p>

                <div class="btn-controls">
                  <f-button text="PIN Entry App" type="button" variant="progressive" class=""></f-button>
                  <f-button text="Cancel" type="button" variant="action" class="hide"></f-button>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          <!-- PIN Entry -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.PEA)" (closed)="closeAccState(eGainConfig.PEA)"
            [expanded]='menuExpansionType(eGainConfig.PEA)' *ngIf="isAuthenticationMethodVisible(eGainConfig.PEA)">
            <mat-expansion-panel-header>
              <mat-panel-title> PIN Entry App </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="pin-container">
              <div class="step-container flex justify-space-between">
                <span class="step-val active"><span class="step-circle active"><span class="step-no">1</span></span>Go
                  to ALIS</span>
                <!-- For tick icon use <i class="fa-solid fa-check"></i> -->
                <span class="step-val"><span class="step-circle"><span class="step-no">2</span></span>Connecting to
                  ALIS</span>
                <span class="step-val hide"><span class="step-circle"><span class="step-no">2</span></span>Transfer the
                  call</span>
                <span class="step-val"><span class="step-circle"><span class="step-no">3</span></span>PIN Entry
                  complete</span>
              </div>
              <p class="pin-content">
                Go to ALIS to transfer the customer to the PIN Entry App.
              </p>
              <p class="pin-content hide">
                The customer will be transferred to ALIS and enter their PIN.
              </p>
              <p class="pin-content hide">
                After the transfer is complete, the customer will return to the
                Care Portal.
              </p>
              <p class="pin-content hide">
                Click on Go to the Customer Overview button to exit the
                Authentication page and proceed with the call.
              </p>

              <div class="btn-controls">
                <f-button text="PIN Entry App" type="button" variant="progressive" class=""></f-button>
                <f-button text="Cancel" type="button" variant="action" class="hide"></f-button>
              </div>
            </div>
          </mat-expansion-panel>
          <!-- Indicative data -->

          <mat-expansion-panel (opened)="cusAccService.getIndicativeData();openAccState(eGainConfig.IND_DATA)"
            (closed)="closeAccState(eGainConfig.IND_DATA)" *ngIf="isAuthenticationMethodVisible(eGainConfig.IND_DATA)"
            [expanded]='menuExpansionType(eGainConfig.IND_DATA)'>
            <mat-expansion-panel-header>
              <mat-panel-title> Indicative Data </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="error-wrapper"
              *ngIf="(rootScope.isLiveCall || rootScope.isLiveChat ) && rootScope.activeCustTab.authenticationIndicativeData.validationFailure">
              <f-alert variant="error">{{validationFailureErrorMessage}}</f-alert>
            </div>
            <div *ngIf="infoWarning()" class="error-wrapper">
              <f-alert variant="info" class="status-msg">{{infoMessage}}</f-alert>
            </div>
            <div *ngIf="showIndicativeDataErr()" class="error-wrapper">
              <f-alert variant="error">{{errorMessage}}
                <span *ngIf="rootScope.activeCustTab.authenticationIndicativeData.indicativeDataAPIFailure">
                  <button (click)="cusAccService.getIndicativeData()" class="btn-alert">Try again</button>
                </span>
              </f-alert>
            </div>
            <p
              *ngIf="rootScope.activeCustTab?.authenticationIndicativeData?.indicativeData && rootScope.activeCustTab?.authenticationIndicativeData?.indicativeData.length > 0&&!infoMessage">
              Enter all information below, then click Validate.
            </p>

            <div class="container validation-method indicative-data" *ngIf="!infoMessage">
              <span
                *ngIf="rootScope.activeCustTab?.authenticationIndicativeData?.indicativeData && rootScope.activeCustTab?.authenticationIndicativeData?.indicativeData.length > 0">
                <form [formGroup]="cusAccService.indicativeDataForm">
                  <span *ngFor="let group of rootScope.activeCustTab?.authenticationIndicativeData?.indicativeData">
                    <!-- Add necessary HTML structure for groups -->

                    <span *ngFor="let subgroup of group.subgroups">
                      <!-- Add necessary HTML structure for subgroups -->

                      <span *ngFor="let section of subgroup.sections">
                        <!-- Add necessary HTML structure for sections -->

                        <span *ngFor="let subgroup of section.sectionsubgroups">
                          <!-- Add necessary HTML structure for sectionsubgroups -->

                          <div class="row" *ngFor="let element of subgroup.elements">
                            <div class="col-md-6">
                              <mat-form-field *ngIf="element.title != 'DOB'" appearance="fill" class="component-box">
                                <mat-label>{{element.key}}</mat-label>
                                <input matInput [id]="element.key" [formControlName]="element.key" autoCompleteOff />
                              </mat-form-field>
                              <mat-form-field *ngIf="element.title == 'DOB'" appearance="fill" class="component-box">
                                <mat-label>Date of Birth (MM/DD/YYYY)</mat-label>
                                <input matInput [max]="maxDate" [id]="element.key" autoCompleteOff
                                  [formControlName]="element.key" [matDatepicker]="picker1" />
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                                <mat-error><i class="fa-solid fa-circle-xmark"></i>{{
                                  getIndicativeDataDobErrorMessages()
                                  }}</mat-error>
                              </mat-form-field>
                            </div>
                            <div *ngIf="element.title == 'FULLNAME'" class="col-md-6">
                              <mat-checkbox [formControlName]="'additionalCheckboxKey'" class="verify-checkbox">
                                The customer’s name is verified.</mat-checkbox>
                            </div>

                            <div *ngIf="cusAccService.checkIVRConfirmation(section)" class="col-md-6">
                              <span class="data-verified "><i class="fa-light fa-circle-check"></i> Confirmed via
                                IVR</span>
                            </div>
                          </div>

                        </span>
                      </span>
                    </span>
                  </span>

                  <div class="row footer-btn">
                    <div class="col-md-12">
                      <f-button text="Cancel"
                        [disabled]="rootScope.activeCustTab.authenticationIndicativeData.indicativeDataValueMiss"
                        (buttonClicked)="onCancelIndicativeData()" type="button" variant="action"></f-button>
                      <f-button text="Validate" [disabled]="indicativeValidation()" (buttonClicked)="onSubmit()"
                        type="button" variant="progressive">
                      </f-button>
                    </div>
                  </div>
                </form>
              </span>
            </div>
          </mat-expansion-panel>

          <!-- Security Q&As -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.SQA)" (closed)="closeAccState(eGainConfig.SQA)"
            [expanded]='menuExpansionType(eGainConfig.SQA)' *ngIf="isAuthenticationMethodVisible('SQA')">
            <mat-expansion-panel-header>
              <mat-panel-title> Security Q&As </mat-panel-title>
            </mat-expansion-panel-header>
            <f-alert variant="info" class="status-msg hide">The customer must set up Q&As on Alight Worklife® to use
              this method.</f-alert>
            <f-alert variant="error" class="status-msg hide">Your answers do not match. <a href="#">Try
                again</a></f-alert>
            <f-alert class="error-with-heading alert-info hide" variant="info">
              <h4>Customer Data Validated</h4>
              <p>The customer must change the PIN to complete the Security Q&A Flow.</p>
            </f-alert>
            <div class="security-form hide1">
              <p>Answer the required security related questions below, then click validate. Answers for these inputs are
                case sensitive.</p>

              <div class="container security-qa">
                <div class="row">
                  <div class="col-md-12">
                    <p class="qa-content">1. What was the last name of your favorite teacher in elementary school?</p>

                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>Example answer</mat-label>
                      <input matInput id="answer1" value="" title="The text is not case sensitive" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p class="qa-content">2. What is the name of your oldest nephew?</p>
                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>Example answer</mat-label>
                      <input matInput id="answer2" value="" title="The text is not case sensitive" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p class="qa-content">3. In what city were you married?</p>
                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>Example answer</mat-label>
                      <input matInput id="answer3" value="" title="The text is not case sensitive" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row footer-btn">
                  <div class="col-md-12">
                    <f-button text="Cancel" type="button" variant="action"></f-button>
                    <f-button text="Validate" type="submit" variant="progressive" disabled="true">
                    </f-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="pin-entry hide">
              <div class="pin-container">
                <div class="step-container flex justify-space-between">
                  <span class="step-val active"><span class="step-circle active"><span class="step-no">1</span></span>Go
                    to ALIS</span>
                  <!-- For tick icon use <i class="fa-solid fa-check"></i> -->
                  <span class="step-val hide"><span class="step-circle"><span class="step-no">2</span></span>Connecting
                    to
                    ALIS</span>
                  <span class="step-val"><span class="step-circle"><span class="step-no">2</span></span>Transfer
                    the call</span>
                  <span class="step-val"><span class="step-circle"><span class="step-no">3</span></span>PIN Change
                    complete</span>
                </div>
                <p class="pin-content hide1">
                  Go to ALIS to transfer the customer to the PIN Entry App.
                </p>
                <p class="pin-content hide">
                  The customer will be transferred to ALIS and enter their PIN.
                </p>
                <p class="pin-content hide">
                  After the transfer is complete, the customer will return to
                  the Care Portal.
                </p>
                <f-alert variant="success" class="status-msg hide">Success! The customer has completed the Security Q&A
                  flow.</f-alert>

                <div class="btn-controls hide1">
                  <f-button text="PIN Entry App" type="button" variant="progressive" class="hide1"></f-button>
                  <f-button text="Cancel" type="button" variant="action" class="hide"></f-button>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          <!-- One Time Code CCR6-572 -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.OTC)" (closed)="closeAccState(eGainConfig.OTC)"
            [expanded]='menuExpansionType(eGainConfig.OTC)' *ngIf="isAuthenticationMethodVisible('OTC')">
            <mat-expansion-panel-header>
              <mat-panel-title> One Time Code </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="main-otc">
              <f-alert variant="success" class="status-msg hide"> Success! Click on Customer Overview to exit the
                Authentication page and proceed with the call.</f-alert>
              <div class="option-otc hide1">
                <p>Choose the option that applies.</p>
                <div class="btn-controls">
                  <f-button text="Request OTC" type="button" variant="action"></f-button>
                  <f-button text="Enter OTC" type="button" variant="progressive"></f-button>
                </div>
              </div>

              <div class="pin-entry hide1">
                <div class="pin-container hide">
                  <div class="step-container flex justify-space-between">
                    <span class="step-val active"><span class="step-circle active"><span
                          class="step-no">1</span></span>Select delivery method</span>
                    <!-- For tick icon use <i class="fa-solid fa-check"></i> -->
                    <span class="step-val"><span class="step-circle"><span class="step-no">2</span></span>Select
                      delivery
                      address
                    </span>
                    <span class="step-val"><span class="step-circle"><span class="step-no">3</span></span>Confirm and
                      send
                    </span>

                  </div>
                </div>
                <div class="email-deliver-method hide">
                  <p class="pin-content">
                    Choose a delivery method:
                  </p>
                  <mat-radio-group [(ngModel)]="selectedValue" color="primary" class="account-selection" disableRipple
                    aria-label="Select an option">
                    <mat-radio-button *ngFor="let opt of options" [value]="opt">{{ opt?.label }}
                    </mat-radio-button>
                  </mat-radio-group>
                  <div class="btn-controls">
                    <f-button text="Cancel" type="button" variant="action" class=""></f-button>
                    <f-button text="Continue" type="button" variant="progressive" class=""></f-button>
                  </div>
                </div>
                <div class="deliver-address hide">
                  <p class="pin-content">
                    Select the address to send the One Time Code to:
                  </p>
                  <mat-radio-group [(ngModel)]="selectedValue" color="primary" class="account-selection hide1"
                    disableRipple aria-label="Select an option">
                    <mat-radio-button *ngFor="let opt of emailoptions" [value]="opt">{{ opt?.label }}
                    </mat-radio-button>
                  </mat-radio-group>

                  <mat-radio-group [(ngModel)]="selectedValue" color="primary" class="account-selection hide"
                    disableRipple aria-label="Select an option">
                    <mat-radio-button *ngFor="let opt of textoptions" [value]="opt">{{ opt?.label }}
                    </mat-radio-button>
                  </mat-radio-group>

                  <f-alert variant="error" class="hide">
                    There is no email on file. Try another method.</f-alert>
                  <f-alert variant="error" class="hide">
                    There is no phone number on file. Try another method.</f-alert>

                  <div class="btn-controls">
                    <f-button text="Back" type="button" variant="action" class=""></f-button>
                    <f-button text="Continue" type="button" variant="progressive" class="" disabled="false"></f-button>
                  </div>
                </div>
                <div class="confirm-send hide">

                  <p class="pin-content hide1">
                    The One Time Code will be sent to b*******c@email.com
                  </p>

                  <p class="pin-content hide">
                    The One Time Code will be sent to ********319
                  </p>


                  <div class="btn-controls">
                    <f-button text="Back" type="button" variant="action" class=""></f-button>
                    <f-button text="Send OTC" type="button" variant="progressive" class=""></f-button>
                  </div>

                </div>
                <div class="success-msg hide">
                  <f-alert variant="success" class="status-msg">Success! The One Time Code has been
                    sent.</f-alert>
                  <ol>
                    <li class="hide1">The One Time Code has been sent to the email address b*******c@email.com</li>
                    <li class="hide">The One Time Code has been sent to the phone number ********319</li>
                    <li>The One Time code is only valid for 10 minutes.</li>
                    <li>Once the code is delivered, click on the Enter a OTC button and enter the code.</li>

                  </ol>
                  <div class="btn-controls">
                    <f-button text="Enter OTC" type="button" variant="progressive"></f-button>
                  </div>
                </div>
              </div>
              <div class="enter-otc hide">
                <p>Enter the One Time Code you have recieved.</p>
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>One Time Code</mat-label>
                      <input [formControl]="oneTimeCode" matInput id="nid" value="1234" />
                      <mat-error><i class="fa-solid fa-circle-xmark"></i>Incorrect Code

                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="btn-controls">
                  <f-button text="Back" type="button" variant="action"></f-button>
                  <f-button text="Verify Code" type="button" variant="progressive"></f-button>
                </div>

              </div>
            </div>
          </mat-expansion-panel>
          <!-- PIN Reset -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.PIN)" (closed)="closeAccState(eGainConfig.PIN)"
            [expanded]='menuExpansionType(eGainConfig.PIN)' *ngIf="isAuthenticationMethodVisible('PIN')">
            <mat-expansion-panel-header>
              <mat-panel-title> PIN Reset </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="pin-reset-container">
              <!-- Steps container valid for Email and Postal Address only -->
              <div class="pin-container hide1">
                <div class="step-container flex justify-space-between">
                  <div class="step-1 flex">
                    <span class="step-val active"><span class="step-circle active"><span
                          class="step-no">1</span></span></span><span>Select the delivery method</span>
                  </div>
                  <!-- For tick icon use <i class="fa-solid fa-check"></i> -->
                  <div class="step-2 flex">
                    <span class="step-val"><span class="step-circle"><span
                          class="step-no">2</span></span></span><span>Select a
                      delivery address</span>
                  </div>
                  <div class="step-3 flex">
                    <span class="step-val"><span class="step-circle"><span class="step-no">3</span></span></span>
                    <span>Confirm and
                      send</span>
                  </div>
                </div>
              </div>
              <!-- For Temporary Address below step container to be used -->
              <p class="pin-content hide">Before you can send a PIN to a temporary address, follow these steps.</p>
              <div class="pin-container hide">
                <div class="step-container flex justify-space-between">
                  <span class="step-val active"><span class="step-circle active"><span class="step-no"><i
                          class="fa-solid fa-check"></i></span></span>Validate customer data</span>
                  <!-- For tick icon use <i class="fa-solid fa-check"></i> -->
                  <span class="step-val active"><span class="step-circle active"><span class="step-no"><i
                          class="fa-solid fa-check"></i></span></span>Set Bad Address
                    indicators </span>
                  <span class="step-val active"><span class="step-circle active"><span
                        class="step-no">3</span></span>Add temporary
                    address</span>
                </div>
              </div>
              <div class="select-delivery-method hide1">
                <mat-radio-group color="primary" class="account-selection hide1" disableRipple
                  aria-label="Select an option" [(ngModel)]="deliveryOption">
                  <mat-radio-button class="delivery-method-button" *ngFor="let method of delivery_method"
                    [value]="method">
                    {{method}}
                  </mat-radio-button>
                </mat-radio-group>
                <div class="btn-controls">
                  <f-button text="Cancel" type="button" variant="action" class=""></f-button>
                  <f-button text="Continue" type="button" variant="progressive" class=""></f-button>
                </div>
              </div>
              <div class="email-method hide">
                <p class="pin-content hide">
                  The new PIN will be sent to this email address:
                </p>
                <p class="pin-content hide">
                  The new PIN will be sent to b*******c@email.com
                </p>
                <p class="pin-content hide">
                  A PIN Reset was sent within the last 15 minutes.
                </p>
                <div class="success-msg">
                  <f-alert variant="success" class="status-msg">Success! The new PIN has been sent.</f-alert>
                  <ol>
                    <li class="hide1">The new PIN has been sent to the email address b*******c@email.com</li>
                    <li>If it doesn’t arrive after 15 minutes, ask the customer to check their spam folder.</li>
                    <li>Using the new PIN, complete the authentication in the PIN Entry App</li>

                  </ol>
                </div>
                <mat-radio-group color="primary" class="account-selection hide" disableRipple
                  aria-label="Select an option" [(ngModel)]="emailOption">
                  <mat-radio-button class="email-method-button" *ngFor="let email of email_method" [value]="email">
                    {{email}}
                  </mat-radio-button>
                </mat-radio-group>
                <div class="btn-controls hide">
                  <f-button text="Back" type="button" variant="action" class="hide"></f-button>
                  <f-button text="Continue" type="button" variant="progressive" class="hide"></f-button>
                  <f-button text="Send PIN Reset" type="button" variant="progressive" class="hide"></f-button>
                  <f-button text="Cancel" type="button" variant="action" class="hide"></f-button>
                  <f-button text="Override and Send PIN Reset" type="button" variant="progressive" class="hide">
                  </f-button>
                </div>
              </div>
              <div class="postal-address hide">
                <p class="pin-content hide1">
                  The new PIN will be sent to this postal address:
                </p>
                <p class="pin-content hide">
                  The new PIN will be sent to: 1*******2 A*****d Av*, S*****d, M**** 1234
                </p>
                <p class="pin-content hide">
                  A PIN Reset was sent within the last 24 hours.
                </p>
                <div class="success-msg hide">
                  <f-alert variant="success" class="status-msg">Success! Your new PIN has been sent.</f-alert>
                  <ol>
                    <li>The new PIN has been sent to the postal address 1**4 A*****d Av*, E******n, IL 6****1</li>
                    <li>The customer won’t be able to access the automated phone system until they receive their new PIN
                    </li>
                    <li>Once the PIN has been received, go to web/ phone to do password reset or call Service Center
                    </li>

                  </ol>
                </div>
                <mat-radio-group color="primary" class="account-selection hide1" disableRipple
                  aria-label="Select an option" [(ngModel)]="postalOption">
                  <mat-radio-button class="postal-method-button" *ngFor="let postal of postal_address" [value]="postal">
                    {{postal}}
                  </mat-radio-button>
                </mat-radio-group>

                <div class="btn-controls hide1">
                  <f-button text="Back" type="button" variant="action" class="hide1"></f-button>
                  <f-button text="Continue" type="button" variant="progressive" class="hide1"></f-button>
                  <f-button text="Send Phone PIN" type="button" variant="progressive" class="hide"></f-button>
                  <f-button text="Override and Send PIN Reset" type="button" variant="progressive" class="hide">
                  </f-button>
                </div>
              </div>
              <div class="temp-address hide">
                <div class="container validation-method hide">
                  <h3>Validate Customer Data</h3>
                  <p class="pin-content">
                    To set a temporary address the customer must be able to confirm personal information. Enter below
                    and select Validate
                  </p>
                  <div class="row">
                    <div class="col-md-6">
                      <mat-form-field appearance="fill" class="component-box">
                        <mat-label>FullName</mat-label>
                        <input matInput id="fullName" value="Al Borland" disabled="true" />
                      </mat-form-field>
                      <mat-checkbox class="verify-checkbox">
                        The customer’s name is verified</mat-checkbox>
                    </div>
                    <div class="col-md-6">
                      <mat-form-field appearance="fill" class="component-box">
                        <mat-label>Date of Birth (MM/DD/YYYY) </mat-label>
                        <input matInput [matDatepicker]="picker">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <mat-form-field appearance="fill" class="component-box">
                        <mat-label>National ID (Last 4)</mat-label>
                        <input matInput id="nid" value="1234" />
                      </mat-form-field>
                    </div>
                    <div class="col-md-6">
                      <mat-form-field appearance="fill" class="component-box">
                        <mat-label>Postal Code</mat-label>
                        <input matInput id="pcode" value="12345" />
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="row footer-btn">
                    <div class="col-md-12">
                      <f-button text="Back" type="button" variant="action"></f-button>
                      <f-button text="Continue" type="submit" variant="progressive">
                      </f-button>
                    </div>
                  </div>
                </div>
                <div class="set-bad-address">
                  <h3 class="hide">Set Bad Address indicators</h3>
                  <h3 class="hide">Add Temporary Address</h3>
                  <p class="pin-content hide">
                    Select address that are no longer valid and should have a bad address indicator set
                  </p>
                  <p class="pin-content">Click <a class="link" href="#"> here</a> to set a temporary address in the
                    source system.</p>
                  <p class="pin-content">Once complete, return here and select Continue.</p>
                  <div class="container set-temp-address hide1">
                    <div class="row">
                      <div class="col-md-6">
                        <mat-radio-group color="primary" class="account-selection hide1" disableRipple
                          aria-label="Select an option" [(ngModel)]="tempOption1">
                          <mat-radio-button class="postal-method-button" *ngFor="let temp of temp_address1"
                            [value]="temp">
                            {{temp}}
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                      <!-- Static dropdown has been used to display the values. Once all the dropdowns are made common, this has to be replaced by Features. -->
                      <div class="col-md-6">
                        <mat-form-field appearance="fill" class="component-box">
                          <mat-label>Bad Address Indicator</mat-label>
                          <mat-select disableRipple disableOptionCentering>
                            <mat-option *ngFor="let tempoption of tempOptions" [value]="tempoption.value">
                              {{ tempoption.viewValue }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <mat-radio-group color="primary" class="account-selection hide1" disableRipple
                          aria-label="Select an option" [(ngModel)]="tempOption2">
                          <mat-radio-button class="postal-method-button" *ngFor="let temp of temp_address2"
                            [value]="temp">
                            {{temp}}
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                      <!-- Static dropdown has been used to display the values. Once all the dropdowns are made common, this has to be replaced by Features. -->
                      <div class="col-md-6">
                        <mat-form-field appearance="fill" class="component-box">
                          <mat-label>Bad Address Indicator</mat-label>
                          <mat-select disableRipple disableOptionCentering>
                            <mat-option *ngFor="let tempoption of tempOptions" [value]="tempoption.value">
                              {{ tempoption.viewValue }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="btn-controls hide1">
                    <f-button text="Cancel" type="button" variant="action" class="hide1"></f-button>
                    <f-button text="Continue" type="button" variant="progressive" class="hide1"></f-button>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- Approved Exceptions -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.APE)" (closed)="closeAccState(eGainConfig.APE)"
            [expanded]='menuExpansionType(eGainConfig.APE)' *ngIf="isAuthenticationMethodVisible('APE')">
            <mat-expansion-panel-header>
              <mat-panel-title> Approved Exceptions </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="exceptions-main">
              <button class="link" [tabindex]="rootScope.activeCustTab.authenticateStatus == fullySecured ? -1 : 0"
                [ngClass]="{'disabledLink': rootScope.activeCustTab.authenticateStatus == fullySecured}"
                (click)="goToApprovedExceptionPage()">Go to the Approved
                Exceptions page.</button>
            </div>
          </mat-expansion-panel>

          <!-- Voluntary Account Lock -->
          <mat-expansion-panel *ngIf="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Voluntary Account Lock </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="vol-lock-container">

              <div class="error-wrapper" *ngIf="true">
                <f-alert variant="info" > A caller needs to be Fully Secured to access this service.</f-alert>
              </div>   
              <!-- Steps container -->
                <div class="step-container flex justify-space-between">
                  <div class="step-1 flex">
                    <span class="step-val active"><span class="step-circle active"><span
                          class="step-no">1</span></span></span><span>Initiate Account Lock App</span>
                  </div>
                 <div class="step-2 flex">
                    <span class="step-val"><span class="step-circle"><span
                          class="step-no">2</span></span></span><span>Transfer the call in ALIS</span>
                  </div>
                  <div class="step-3 flex">
                    <div class="success hide">
                        <span class="step-val"><span class="step-circle"><span class="step-no">3</span></span></span>
                        <span>Completed</span>
                    </div>

                    <div class="failed">
                      <i class="fa-sharp fa-solid fa-circle-xmark red"></i>
                        <span>Failed</span>                      
                  </div>                    
                  </div>                  
                </div>
                  
                  
                   <!-- For step-1 content  -->
                  <div class="steps-content hide">
                    <p>Make sure they have a valid phone number on file. If there isn’t one on file get one added and THEN route them to the Account Lock App.</p>
                    <h4>Click on the Account Lock button to initiate the Account Lock process.</h4>
                    <div class="btn-controls">
                      <f-button text="Accont Lock" type="button" variant="progressive" class=""></f-button>
                    </div> 
                  </div>
                  <!-- For step-2 content  -->
                  <div class="steps-content hide">
                    <div class="select-lang-method ">
                      <p>Select the language the Account Lock App should be spoken in.</p>
                      <mat-radio-group color="primary" class="account-selection hide1" disableRipple
                        aria-label="Select an option" [(ngModel)]="langOption">
                        <mat-radio-button class="delivery-method-button" *ngFor="let method of lang_method"
                          [value]="method">
                          {{method}}
                        </mat-radio-button>
                      </mat-radio-group>
                      <div class="btn-controls">
                        <f-button text="Cancel" type="button" variant="action" class=""></f-button>
                        <f-button text="Continue" type="button" variant="progressive" class=""></f-button>
                      </div>
                    </div>
                  </div>
                   <!-- For step-3 content  -->  
                  <div class="steps-content hide">
                    <p>Go to ALIS to transfer the customer to the Voluntary Account Lock App by selecting “Consult”, search “Lock”, and select “Account Lock Voice ALV, ALIS”.</p>
                  </div>
                  <div class="steps-content hide1">
                    <div class="error-wrapper" *ngIf="true">
                      <f-alert variant="success" class="hide">The Account has been voluntarily locked by the caller to prevent DB and
                         DC payments from all channels.</f-alert>

                         <f-alert variant="error" class="hid1e">Account Lock failed! Account remains locked due to maximum number of invalid unlock key attempts. Inform the caller to try 
                          unlock their account by logging on to the website or calling back after 15 minutes.</f-alert>  
                    </div>
                  </div>
                  
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <div class="col-md-12 col-lg-6 authentication-right authentication-main">
        <div class="authentication-content">
          <section *ngIf="rootScope.activeCustTab?.authenticationEgainContent?.authEgainError">
            <f-alert variant="error" class="status-msg hide1">
              {{rootScope.activeCustTab?.authenticationEgainContent?.authEgainError}}</f-alert>
          </section>
          <h1>{{rootScope.activeCustTab?.authenticationEgainContent?.authenticationHtml?.name}}</h1>
          <div
            [innerHTML]="rootScope.activeCustTab?.authenticationEgainContent?.authenticationHtml?.content| safe: 'html'">
          </div>
        </div>
        <!-- Pin reset conetent as per CCR3-2382  -->

        <!-- <div class="authentication-content">

          <h2>
            Important notes about PIN Reset
          </h2>

          <p> Follow the steps in the flow to the left to process a PIN Reset</p>

          <h3>BEFORE Processing a PIN Reset</h3>

          <ul>
            <li>Confirm which channel(s) the customer can access to resolve their issue, and explain options


              <ul>

                <li>Web/Mobile: Customer can enter credentials (ID & Password) or do a Password Reset. Once
                  authenticated they can create or change their PIN, add a mobile number or email (if supported
                  for client) to use for One-time Code, or set-up or change Security Questions (if supported). And
                  ideally, resolve their issue. </li>

                <li>Service Center: Proceed with Reset flow</li>
              </ul>
            </li>

          </ul>

          <h3>Email Delivery Method (if offered)</h3>

          <ul>
            <li>The following communications will be sent shortly:
              <ul>
                <li> Email containing the temporary PIN</li>
                <li> Email with instructions on how to use the temporary PIN and how to create a permanent PIN </li>
                <li>Email with confirmation of the request, sent to preferred email address regardless of address
                  used for PIN Reset</li>
              </ul>
            </li>
            <li>If the email address the customer wishes to use is not on file, direct them to the Web to authenticate,
              from there they can update email address. </li>
            <li>15 minute waiting period between sending PIN Resets by Email; this can be overridden and if done, any
              prior ones will be invalid</li>
            <li>Email delivery is not supported for DB and/or DC clients</li>
          </ul>

          <h3>Postal Delivery Method </h3>
          <ul>
            <li> The following communications will be sent tomorrow, allow time for delivery:
              <ul>
                <li> Postal notice containing the temporary PIN</li>
                <li> Postal notice with confirmation of the request, sent to preferred and permanent addresses
                  regardless of address used for the reset</li>

              </ul>
            </li>
            <li>24 hour waiting period between sending PIN Resets by Postal; this can be overridden and if done, any
              prior ones will be invalid</li>
            <li> If the postal address the customer wishes to use is not on file, follow the Temporary Address flow when
              selecting a delivery address</li>
          </ul>

          <h3>AFTER Processing a PIN Reset</h3>

          <ul>
            <li>Review communications the customer will receive and timing</li>
            <li>Encourage customer to enter the temporary PIN in the automated voice channel and then create a permanent
              PIN</li>
          </ul>


        </div> -->






        <!-- <div class="flex justify-space-between notes">
          <h2>
            Important notes about
            <span class="dynamic-text hide1">PIN Reset</span>
          </h2>
          <button mat-button color="primary" class="show-hide" (click)="methodInstruction = !methodInstruction">
            {{ methodInstruction ? "Show Less" : "Show More" }}

            <span *ngIf="!methodInstruction"><i class="fa-regular fa-angle-down"></i></span>
            <span *ngIf="methodInstruction"><i class="fa-regular fa-angle-up"></i></span>
          </button>
        </div> -->

        <!-- <i class="fa-regular fa-angle-up"></i>  <i class="fa-regular fa-angle-down"></i> -->
        <!-- <div class="show-hide-data hide1 notes-container" *ngIf="methodInstruction">
         
         <p class="dynamic-content hide">
            When the FTU method is selected the CCR must ask for, manually
            enter, and validate the following data elements
          </p>
          <h2><span class="dynamic-text hide">Steps for First Time User</span></h2>
          <ol>
            <li>Before processing Phone PIN Reset, confirm which channel customer wants to access. For web/mobile, go to web/mobile site for a Password Reset. If Service Center, continue.</li>

            <li>If the email address on file is incorrect or need to add a different email, go to web/ mobile to do password reset.</li>

            <li>If the postal address on file is incorrect or need to add a different postal address, set a bad address indicator and process a temporary address change.</li>

            <li>After it is done, return here and in the delivery method, select the newly added temporary address.</li>

            <li>The customer won’t be able to access the automated phone system until they receive their new PIN.</li>
          </ol> 
        </div> -->
      </div>
    </div>
  </div>
</f-data-card>